import { render, staticRenderFns } from "./FolderLayoutModal.vue?vue&type=template&id=9c5b43f6&scoped=true"
import script from "./FolderLayoutModal.vue?vue&type=script&lang=ts"
export * from "./FolderLayoutModal.vue?vue&type=script&lang=ts"
import style0 from "./FolderLayoutModal.vue?vue&type=style&index=0&id=9c5b43f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5b43f6",
  null
  
)

export default component.exports